import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

const TeacherNotifications = ({ events, settings }) => {
    const getNotifications = () => {
        const notifications = [];
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

        // Check for today's events
        const todayEvents = events.filter(event => {
            const eventDate = new Date(event.start);
            return eventDate >= today && eventDate < tomorrow;
        });

        if (todayEvents.length === 0) {
            notifications.push({
                type: 'info',
                icon: 'mdi:calendar-blank',
                title: 'אין אירועים היום',
                message: 'היום אין לך שיעורים או אירועים מתוכננים',
                link: '/calendar'
            });
        } else {
            notifications.push({
                type: 'success',
                icon: 'mdi:calendar-check',
                title: `${todayEvents.length} אירועים היום`,
                message: `יש לך ${todayEvents.length} אירועים מתוכננים להיום`,
                link: '/calendar'
            });
        }

        // Check for upcoming tests
        const upcomingTests = events.filter(event => {
            const eventDate = new Date(event.start);
            return (event.extendedProps?.type === 'test' || event.extendedProps?.type === 'internalTest') &&
                eventDate > now && eventDate <= new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
        });

        if (upcomingTests.length > 0) {
            notifications.push({
                type: 'warning',
                icon: 'mdi:clipboard-alert',
                title: `${upcomingTests.length} טסטים קרובים`,
                message: `יש לך ${upcomingTests.length} טסטים בשבוע הקרוב`,
                link: '/calendar'
            });
        }

        // Check for lesson requests
        const lessonRequests = events.filter(event =>
            event.extendedProps?.type === 'lessonRequest'
        );

        if (lessonRequests.length > 0) {
            notifications.push({
                type: 'info',
                icon: 'mdi:calendar-plus',
                title: `${lessonRequests.length} בקשות שיעור`,
                message: `יש ${lessonRequests.length} בקשות לקביעת שיעור חדש`,
                link: '/calendar'
            });
        }

        // Check for cancellation requests
        const cancellationRequests = events.filter(event =>
            event.extendedProps?.type === 'cancelationRequest'
        );

        if (cancellationRequests.length > 0) {
            notifications.push({
                type: 'danger',
                icon: 'mdi:calendar-remove',
                title: `${cancellationRequests.length} בקשות ביטול`,
                message: `יש ${cancellationRequests.length} בקשות לביטול שיעור`,
                link: '/calendar'
            });
        }

        return notifications;
    };

    const notifications = getNotifications();

    const getNotificationColor = (type) => {
        switch (type) {
            case 'success': return 'success';
            case 'warning': return 'warning';
            case 'danger': return 'danger';
            case 'info':
            default: return 'info';
        }
    };

    if (notifications.length === 0) {
        return null;
    }

    return (
        <div className="card h-100">
            <div className="card-header border-bottom">
                <h6 className="fw-bold text-lg mb-0">התראות</h6>
            </div>
            <div className="card-body p-24">
                <div className="d-flex flex-column gap-3">
                    {notifications.map((notification, idx) => (
                        <div key={idx} className={`alert alert-${getNotificationColor(notification.type)} d-flex align-items-center gap-3`}>
                            <Icon
                                icon={notification.icon}
                                className={`text-${getNotificationColor(notification.type)} text-xl`}
                            />
                            <div className="flex-grow-1">
                                <h6 className="mb-1 fw-semibold">{notification.title}</h6>
                                <p className="mb-0 text-sm">{notification.message}</p>
                            </div>
                            {notification.link && (
                                <Link to={notification.link} className="btn btn-sm btn-outline-primary">
                                    צפה
                                </Link>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TeacherNotifications; 